import React from "react";

/** The notification bell (line style, 24-unit grid). `dot` draws the clapper solid for "something new". */
export default function BellIcon({
  size = 22,
  dot = false,
  className = ""
}) {
  return /*#__PURE__*/React.createElement("svg", {
    className: "nc-bell-svg " + className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    focusable: "false"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.25c-3.2 0-5.6 2.45-5.6 5.6v2.9c0 .9-.3 1.75-.85 2.45l-1.05 1.35c-.55.7-.05 1.7.85 1.7h13.3c.9 0 1.4-1 .85-1.7l-1.05-1.35c-.55-.7-.85-1.55-.85-2.45v-2.9c0-3.15-2.4-5.6-5.6-5.6Z",
    stroke: "currentColor",
    strokeWidth: size >= 22 ? 1.9 : 1.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 19.4a2.5 2.5 0 0 0 4.8 0",
    stroke: "currentColor",
    strokeWidth: size >= 22 ? 1.9 : 1.7,
    strokeLinecap: "round",
    fill: dot ? "currentColor" : "none"
  }));
}